'use client';

import { PopImage } from '@ps/ui/atoms/pop-image';

export function CommentAvatar({
  src,
  fallback,
}: {
  src?: string;
  fallback: string;
}) {
  const initial = (fallback ?? '?').trim().charAt(0).toUpperCase();
  if (!src) {
    return (
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-black/10 text-[12px] font-semibold text-black/70">
        {initial}
      </div>
    );
  }
  return (
    <div className="relative h-8 w-8 shrink-0 overflow-hidden rounded-full bg-black/5">
      <PopImage
        src={src}
        alt=""
        fill
        sizes="32px"
        resizing={{ width: 32, height: 32, fit: 'cover' }}
        resizeMode="cover"
      />
    </div>
  );
}
